<template>
  <div>
    <SearchPannel @search="search" @exp="exp" />
    <div class="pd-20">
      <a-table :columns="columns" :row-key="getKey" :data-source="list" :pagination="pagination" @change="handleTableChange">
        <div slot="transactionType" slot-scope="row">
          {{ transactionType[row.transactionType] }}
        </div>
        <div slot="status" slot-scope="row">
          {{ status[row.status] }}
        </div>
      </a-table>
    </div>
  </div>
</template>
<script>
import SearchPannel from './searchPannel'
const columns = [
  { title: '交易时间', dataIndex: 'updateTime', key: 'updateTime' },
  { title: '下单时间', dataIndex: 'createTime', key: 'createTime' },
  { title: '快递单号', dataIndex: 'logisticCode ', key: 'logisticCode' },
  { title: '交易类型', key: 'transactionType', scopedSlots: { customRender: 'transactionType' }},
  { title: '交易金额（元）', dataIndex: 'transactionAmount', key: 'transactionAmount' },
  { title: '交易流水', dataIndex: 'serialNumber', key: 'serialNumber' },
  { title: '交易状态', key: 'status', scopedSlots: { customRender: 'status' }}
]

export default {
  components: {
    SearchPannel
  },
  data() {
    return {
      status: {
        0: '待交易',
        1: '交易成功',
        2: '交易失败'
      },
      transactionType: {
        1: '充值',
        2: '运费',
        3: '赔付'
      },
      columns,
      params: {
        'startTime': this.$moment().format('YYYY-MM-DD'),
        'endTime': this.$moment().format('YYYY-MM-DD')
      },
      list: [],
      pagination: {
        'current': 1,
        'pageSize': 10,
        total: 0
      }
    }
  },
  created() {
    this.getList()
  },
  methods: {
    async exp(button) {
      try {
        button.loading = true
        this.params.pageIndex = this.pagination.current
        this.params.pageSize = this.pagination.pageSize
        this.$down(this.$api.accountExportTransactionRecord, this.params)
        button.loading = false
      } catch (error) {
        button.loading = false
      }
    },
    getKey(key) {
      return parseInt(Math.random() * 1000)
    },
    async handleTableChange(pagination) {
      this.pagination = { ...pagination }
      this.getList()
    },
    search(params) {
      this.pagination.current = 1
      this.getList(params)
    },
    async getList(params) {
      if (params) {
        Object.assign(this.params, params)
      }
      this.params.pageIndex = this.pagination.current
      this.params.pageSize = this.pagination.pageSize
      const res = await this.$http(this.$api.accountGetTransactionRecord, this.params)
      if (res) {
        this.list = res.list || []
        this.pagination.current = res.pageIndex
        this.pagination.pageSize = res.pageSize
        this.pagination.total = res.totalSize
      }
    }
  }
}
</script>
